export default __webpack_public_path__ + "static/media/SeyiAdebayo.30aa329c.jpg";